/** @module SiteAdmin/Document/OwnerTable */
define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"underscore",
	"csi",
	"csi/locale",
	"csi/reflection",
	"csi/reflectionHints",
	"csi/table/TypeSwitchboardTable",
	"csi/xml",
	"csi/xml/Query",
	//extra dependencies
	"./RefDocWizToolbar"
], function(declare, Memory, _, csi, locale, reflection, reflectionHints, TypeSwitchboardTable, xml, Query) {

	var _ownerStore;

	function _getOwnerStore() {
		if (!_ownerStore) {
			var ownerTypes = reflectionHints.getReferenceDocumentOwners();
			var data = _.reduce(ownerTypes, function(memo, type) {
				var rc = reflection.getClass(type);
				if (rc && !rc.abstractOrDisabled && rc.isDerivedFrom("DocAndCommentOwner")) {
					memo.push({id: type, name: locale.type(type)});
				}

				return memo;
			}, []);

			_ownerStore = new Memory({
				data: csi.sort(data, "name")
			});
		}

		return _ownerStore;
	}

	return declare(TypeSwitchboardTable, {
		toolbarClass: "SiteAdmin/Document/RefDocWizToolbar",
		selectorOnSecondary: true,

		/**
		 * @override
		 * Initialize headings based on target type of view (or the source type of view if not yet set)
		*/
		onViewInitializeAttributes() {
			const {containerSourceType, containerTargetType, defView} = this;
			const type = containerTargetType || containerSourceType;

			defView.m_headings = [
				_.extend(defView.newHeading(), {m_id: type + ".Default", m_bCard: true}),
				_.extend(defView.newHeading(), {m_id: "CntDocuments"})
			];
		},

		/**
		 * Retrieve the DocumentContainer based on the context of where
		 * this operation is called from
		 * @return {Node}
		 */
		retrieveContainer: function() {
			return this.getViewNode();
		},

		/**
		 * Add type switchboard to plugin and set default value for container type to select from
		 */
		_resolveView: function() {
			const container = this.retrieveContainer();
			if (container) {
				const owner = this.cacheView.getNode(container.__Parent__);

				if (reflection.isRevisionNode(owner)) {
					this.set("containerQuery", new Query().Node(xml.PROP_FLAGS, xml.OP_BIT_0, xml.NODE_FLAG_FROZEN));
				} else {
					this.set("containerQuery", null);
				}

				if (owner && (owner.$Type != "DocumentGroup")) {
					this.set("containerSourceType", owner.$Type);
					this.set("containerSourceUrl", owner.$URL);
				} else {
					this.set("containerSourceType", "Style");
				}

				this.set("containerTypeStore", _getOwnerStore());
			}

			this.inherited(arguments);
		}
	});
});
